import { LoadState } from "../../constants/enums";

export interface IAIExcelFileExtractHeadersPayload {
  heading_row_start: number;
  heading_row_end: number;
  sheet_count: number;
  type: string;
  url: string;
  company_code?: string;
  llm_prompt?: string;
  extract_type?: string;
  reconcile_for?: string;
  selected_table?: string;
  project_name?: string;
  project_instructions?: string;
  is_update_transaction?: string;
  payment?: string;
  // insurer: string;
  // broker_code: string;
  // bank: string;
  // date: string;
}

export interface IAccountReconciliationDocument {
  reconciliation_document_code: string | null;
  reconciliation_document_name: string | null;
  file_path: string;
  file_type: "EXCEL" | "Pdf" | "Excel";
  status: "ACTIVE" | "INACTIVE";
  type: string | null;
  company_code?: string | null;
  llm_prompt?: string | null;
  extract_type?: string | null;
  reconcile_for?: string | null;
  selected_table?: string | null;
  project_name?: string | null;
  project_instructions?: string | null;
  is_update_transaction?: number | null;
  payment?: string | null;
  // insurer: string;
  // broker_code: string;
  // bank: string;
  // date: string;
  // read only
  create_ts?: string;
  insert_ts?: string;
}
export interface ITempBillPayment {
  temp_bill_payment_id: number | null;
  bill_payment_code: string | null;
  file_path: string;
  file_type: "EXCEL" | "Pdf" | "Excel";
  start_row: number;
  end_row: number;
  type?: string | null;
  template_mapping_data: {
    [key: string]: string;
  };
  status: "ACTIVE" | "INACTIVE";
  // read only
  create_ts?: string;
  insert_ts?: string;
}

export interface ITempInvoicePayment {
  temp_invoice_payment_id: number | null;
  invoice_payment_code: string | null;
  file_path: string;
  file_type: "EXCEL" | "Pdf" | "Excel";
  start_row: number;
  end_row: number;
  type: string | null;
  template_mapping_data: {
    [key: string]: string;
  };
  status: "ACTIVE" | "INACTIVE";
  // read only
  create_ts?: string;
  insert_ts?: string;
}

export interface IBillExtraction {
  bill_date: string;
  vendor: string;
  amount_due: string;
  description: string;
  amount_paid: string;
  bill_payment_code: string;
  created_by_id: number;
  modified_by_id: number;
  modified_by_name: string;
  created_by_name: string;
  temporary_transaction_item_status: string;
  status: string;
  accn_transaction_id: number;
  create_ts: string;
  gl_account_code: string;
  transaction_type: string;
}

export interface IInvoiceBillExtraction {
  create_ts: string;
  created_by_id: number;
  created_by_name: string;
  date: string | null;
  invoice_payment_code: string;
  modified_by_id: number;
  modified_by_name: string;
  payment_date: string | null;
  payment_id: number;
  payment_made: string | null;
  reference_id: string | null;
  status: string;
}
export interface IInvoicePaymentExtraction {
  create_ts: string;  
  created_by_id: number;
  created_by_name: string;
  date: string;
  invoice_payment_code: string;
  modified_by_id: number;
  modified_by_name: string;
  payment_amount: string | null;
  payment_id: number;
  reference_info: string;
  status: string;
}

export interface IComparisonDetails {
  accn_reconciliation_comparison_details_id: string;
  comparison_details_code: string;
  reconciliation_document_code: string;
  reconciliation_template_code: string;
  mapping_code: string;
  primary_key: null;

  reconciliation_status: "matched" | "unmatched";
  comment: string | null;
  status: string;
  created_by_id: number;
  created_by_name: number;
  modified_by_id: number;
  modified_by_name: string;
  create_ts: string;
  insert_ts: string;
  diffs: {
    [key: string]: {
      import: any;
      db: any;
    };
  };
}

export interface IUploadPdfDocumentProcess {
  reconciliation_document_code: string;
  process_records_code: string;
  total_products: number;
  completed_products: number;
  status: "IN_PROGRESS" | "COMPLETED" | "FAILED";
  created_by_uuid: any;
  created_by_name: any;
  modified_by_uuid: any;
  modified_by_name: any;
  create_ts?: string;
  insert_ts?: string;
}

export interface IAccountReconciliationDetails {
  total_records: number;
  matched_records: number;
  unmatched_records: number;
  records_with_differences: number;
  comparison_details: IComparisonDetails[];
  commission_paid: string | null;
  payment_paid_date: string | null;
  template_code: string | null;
  reconciliation_document_code: string | null;
  producer_paid: string | null;
  company_paid: string | null;
  company_paid_date: string | null;
  producer_paid_date: string | null;
  default_transaction_date?: string;
  reconcile_for: string | null;
  bank_reconciled: string | null;
  bank_reconciled_date: string | null;
  type: string | null;
  insurer: string | null;
  broker_code: string | null;
  date: string | null;
}

export interface IAccountReconciliationDetailsList {
  reconciliation_summary_id: string;
  reconciliation_summary_code: string;
  file_url: string | null;
  date_created: string | null;
  type: string | null;
  template_code: string;
  reconciliation_document_code: string | null;
  matched_records: string | null;
  unmatched_records: string | null;
  records_with_differences: string | null;
  total_records: string | null;
  status: string | null;
  created_by_id: string | null;
  modified_by_id: string | null;
  create_ts: string | null;
  insert_ts: string | null;
  assigned_to_code: string | null;
  assigned_to_id: number | null;
  assigned_to_name: string | null;
  insurer: string | null;
  broker_code: string | null;
  bank: string | null;
  date: string | null;
  reconcile_for: string | null;
}

export interface IExtractedPfdDataObject {
  [key: string]: string;
}

export interface IExtractedPdfData {
  extracted_pdf_data_id: string;
  extracted_pdf_data_code: string;
  reconciliation_document_code: string;
  pdf_data: IExtractedPfdDataObject[];
}
export type ReconciliationJobStatus =
  | "IDLE"
  | "SUBMITTING"
  | "QUEUED"
  | "PROCESSING"
  | "FAILED"
  | "COMPLETED"
  | "DEAD_LETTER"
  | "TIMED_OUT"
  | "NETWORK_ERROR";

export interface IReconciliationPollingProgress {
  totalRecords: number;
  processedRecords: number;
  matchedRecords: number;
  unmatchedRecords: number;
  recordsWithDifferences: number;
  progressPercent: number;
  progressStage: string | null;
}

export interface IReconciliationPollingState {
  processLogCode: string | null;
  pollingStatus: ReconciliationJobStatus;
  errorMessage: string | null;
  consecutiveFailures: number;
  pollingStartedAt: number | null; // timestamp in ms
  progress: IReconciliationPollingProgress;
}

export interface IAccountReconciliationState {
  list: IAccountReconciliationDetailsList[];
  totalRecords: number;
  loading: LoadState;
  reconciliationDetails: IAccountReconciliationDetails;
  reconciliationDetailsLoading: LoadState;
  reconciliationDetailsError: string | null;
  polling: IReconciliationPollingState;
}

export const initialPollingProgress: IReconciliationPollingProgress = {
  totalRecords: 0,
  processedRecords: 0,
  matchedRecords: 0,
  unmatchedRecords: 0,
  recordsWithDifferences: 0,
  progressPercent: 0,
  progressStage: null,
};

export const initialPollingState: IReconciliationPollingState = {
  processLogCode: null,
  pollingStatus: "IDLE",
  errorMessage: null,
  consecutiveFailures: 0,
  pollingStartedAt: null,
  progress: initialPollingProgress,
};

export const initialAccountReconciliationState: IAccountReconciliationState = {
  list: [],
  loading: LoadState.NotLoaded,
  totalRecords: 0,
  reconciliationDetails: {
    matched_records: 0,
    records_with_differences: 0,
    comparison_details: [],
    total_records: 0,
    unmatched_records: 0,
    producer_paid: "N",
    producer_paid_date: null,
    commission_paid: null,
    payment_paid_date: null,
    template_code: null,
    reconciliation_document_code: null,
    company_paid: "N",
    company_paid_date: null,
    reconcile_for: null,
    bank_reconciled: null,
    bank_reconciled_date: null,
    type: null,
    insurer: null,
    broker_code: null,
    date: null,
  },
  reconciliationDetailsError: null,
  reconciliationDetailsLoading: LoadState.NotLoaded,
  polling: initialPollingState,
};
